import { useEffect, useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'Founder, FitLife App',
    avatar: 'https://public.readdy.ai/ai/img_res/f30855b0dc4d09d43b99c287bac548d4.jpg',
    content: 'Your App Wizard transformed my fitness coaching business. I built a fully functional app in just 3 days without writing a single line of code. My clients love it!',
    rating: 5,
    appType: 'Fitness App',
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Owner, Dragon Wok Restaurant',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20friendly%20asian%20male%20business%20owner%20with%20confident%20expression%20wearing%20smart%20casual%20shirt%20against%20neutral%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=200&height=200&seq=testimonial-avatar-man-002&orientation=squarish',
    content: 'Our restaurant app has increased online orders by 300%. The drag-and-drop builder made it so easy to showcase our menu and enable delivery tracking.',
    rating: 5,
    appType: 'Restaurant App',
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Real Estate Agent',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20elegant%20hispanic%20woman%20professional%20with%20friendly%20smile%20wearing%20blazer%20against%20soft%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=200&height=200&seq=testimonial-avatar-woman-003&orientation=squarish',
    content: 'The real estate template was perfect for my needs. I customized it with my listings and now my clients can browse properties on the go. Game changer!',
    rating: 5,
    appType: 'Real Estate App',
  },
  {
    id: 4,
    name: 'David Thompson',
    role: 'Founder, StyleHub',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20creative%20young%20male%20entrepreneur%20with%20stylish%20appearance%20wearing%20casual%20shirt%20against%20modern%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=200&height=200&seq=testimonial-avatar-man-004&orientation=squarish',
    content: 'As a fashion designer, I needed a beautiful portfolio app. Your App Wizard delivered beyond my expectations. The customization options are endless!',
    rating: 5,
    appType: 'Portfolio App',
  },
  {
    id: 5,
    name: 'Jessica Martinez',
    role: 'Salon Owner',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20cheerful%20young%20woman%20business%20owner%20with%20bright%20smile%20wearing%20elegant%20attire%20against%20clean%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=200&height=200&seq=testimonial-avatar-woman-005&orientation=squarish',
    content: 'The booking system template saved me thousands in development costs. My clients can now book appointments 24/7. The support team is amazing!',
    rating: 5,
    appType: 'Booking App',
  },
  {
    id: 6,
    name: 'Robert Kim',
    role: 'eCommerce Entrepreneur',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20successful%20asian%20male%20entrepreneur%20with%20confident%20demeanor%20wearing%20business%20shirt%20against%20neutral%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=200&height=200&seq=testimonial-avatar-man-006&orientation=squarish',
    content: 'I launched my online store app in less than a week. The payment integration was seamless and my sales have doubled since going mobile!',
    rating: 5,
    appType: 'eCommerce App',
  },
];

export default function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('testimonials');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className={`inline-flex items-center gap-2 px-5 py-2.5 bg-purple-100 rounded-full text-purple-700 mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <i className="ri-chat-quote-line"></i>
            <span className="text-sm font-semibold">Success Stories</span>
          </div>
          <h2 className={`text-5xl font-extrabold text-gray-900 mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            Loved by Creators Worldwide
          </h2>
          <p className={`text-xl text-gray-600 max-w-2xl mx-auto transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            Join thousands of entrepreneurs who have built successful apps with Your App Wizard
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-purple-200 hover:shadow-xl transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              {/* Rating */}
              <div className="flex items-center gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-100">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>

              {/* App Type Badge */}
              <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg">
                <i className="ri-smartphone-line text-purple-600"></i>
                <span className="text-sm font-semibold text-purple-700">{testimonial.appType}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className={`mt-20 text-center transition-all duration-700 delay-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-12 px-12 py-8 bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl border-2 border-purple-100">
            <div className="text-center">
              <div className="text-4xl font-extrabold text-gray-900 mb-2">4.9/5</div>
              <div className="text-sm text-gray-600 font-medium">Average Rating</div>
            </div>
            <div className="w-px h-12 bg-purple-200"></div>
            <div className="text-center">
              <div className="text-4xl font-extrabold text-gray-900 mb-2">10K+</div>
              <div className="text-sm text-gray-600 font-medium">Happy Creators</div>
            </div>
            <div className="w-px h-12 bg-purple-200"></div>
            <div className="text-center">
              <div className="text-4xl font-extrabold text-gray-900 mb-2">98%</div>
              <div className="text-sm text-gray-600 font-medium">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}